import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  class: "text-center",
  width: "64px"
}
const _hoisted_3 = { class: "text-left pl-4" }
const _hoisted_4 = { class: "text-left pl-4" }
const _hoisted_5 = { class: "text-right pr-10" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "text-right" }
const _hoisted_10 = { class: "text-right" }
const _hoisted_11 = {
  key: 1,
  class: "text-right"
}
const _hoisted_12 = { align: "end" }
const _hoisted_13 = { style: {"background":"#fff"} }
const _hoisted_14 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_oss_data_table = _resolveComponent("oss-data-table")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, {
    "no-gutters": "",
    class: "pa-3"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: "12",
        class: "pb-2"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createElementVNode("h1", null, "Rapprochements bancaires", -1)
        ])),
        _: 1
      }),
      _createVNode(_component_v_col, { cols: "12" }, {
        default: _withCtx(() => [
          _createVNode(_component_oss_data_table, {
            headers: _ctx.headers,
            items: _ctx.items,
            striped: true,
            dense: true,
            loading: _ctx.loading
          }, {
            item: _withCtx(({ item }) => [
              (_openBlock(), _createElementBlock("tr", {
                class: "bankLine",
                key: item.id,
                onClick: ($event: any) => (_ctx.addRemoveItemExpanded(item))
              }, [
                _createElementVNode("td", _hoisted_2, [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.isItemExpanded(item) ? "$fa-chevron-down" : "$fa-chevron-up"), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("td", _hoisted_3, [
                  _createElementVNode("strong", null, _toDisplayString(item.name), 1)
                ]),
                _createElementVNode("td", _hoisted_4, [
                  _createElementVNode("strong", null, _toDisplayString(item.iban || ""), 1)
                ]),
                _createElementVNode("td", _hoisted_5, [
                  _createElementVNode("strong", null, " Écart : " + _toDisplayString(_ctx.newCommonFormatCurrency(item.balanceReconciliation, undefined)), 1)
                ])
              ], 8, _hoisted_1)),
              (_ctx.isItemExpanded(item))
                ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                    (_openBlock(), _createElementBlock("td", {
                      colspan: 6,
                      style: {"padding":"0","background":"#f4f4f4"},
                      class: "pa-2",
                      key: _ctx.refreshKey
                    }, [
                      _createVNode(_component_oss_data_table, {
                        headers: _ctx.headersExtendeTable,
                        items: item.balances,
                        striped: true,
                        dense: true,
                        height: 'calc(100vh - 350px)',
                        displayRowNumber: true
                      }, {
                        item: _withCtx(({ item: balance, index: balanceIndex }) => [
                          _createElementVNode("tr", {
                            onClick: _withModifiers(($event: any) => (_ctx.addRemoveItemExpanded(balance.selected)), ["stop"])
                          }, [
                            _cache[4] || (_cache[4] = _createElementVNode("td", null, null, -1)),
                            _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(balance.date)), 1),
                            _createElementVNode("td", null, [
                              (
                                                    balance.balances && balance.balances.length > 1
                                                )
                                ? (_openBlock(), _createBlock(_component_v_select_filled, {
                                    key: 0,
                                    modelValue: balance.selected,
                                    "onUpdate:modelValue": [($event: any) => ((balance.selected) = $event), ($event: any) => (
                                                    _ctx.selectedBalanceChanged(balance)
                                                )],
                                    items: balance.balances,
                                    "item-title": _ctx.getBalanceTypeText,
                                    "return-object": "",
                                    outlined: "",
                                    "hide-details": "",
                                    readonly: balance.balances.length === 1,
                                    density: "compact"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title", "readonly"]))
                                : (balance.balances.length === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.getBalanceTypeText(balance.selected)), 1))
                                  : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                    balance.selected.balance,
                                                    undefined,
                                                )), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        balance.glBalance,
                                                        undefined,
                                                    )), 1)
                            ]),
                            _createElementVNode("td", null, [
                              (balance.selected.balance)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "text-right",
                                    style: _normalizeStyle(
                                                    _ctx.differenceColor(
                                                        balance.selected.balance,
                                                        balance.glBalance,
                                                    )
                                                )
                                  }, [
                                    _createElementVNode("strong", null, _toDisplayString(_ctx.difference(
                                                            balance.selected.balance,
                                                            balance.glBalance,
                                                        )), 1)
                                  ], 4))
                                : (_openBlock(), _createElementBlock("div", _hoisted_11, "-"))
                            ]),
                            _createElementVNode("td", _hoisted_12, [
                              _createVNode(_component_v_menu, { "offset-y": "" }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props), null, 16)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list, null, {
                                    default: _withCtx(() => [
                                      balanceIndex
                                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                                            key: 0,
                                            onClick: ($event: any) => (_ctx.showBTs(item, balanceIndex))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, null, {
                                                default: _withCtx(() => _cache[2] || (_cache[2] = [
                                                  _createTextVNode(" Afficher ")
                                                ])),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_v_list_item, {
                                        onClick: ($event: any) => (_ctx.deleteBalance(item, balanceIndex))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list_item_title, null, {
                                            default: _withCtx(() => _cache[3] || (_cache[3] = [
                                              _createTextVNode(" Supprimer ")
                                            ])),
                                            _: 1
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ], 8, _hoisted_7)
                        ]),
                        "body.append": _withCtx(() => [
                          _createElementVNode("tr", _hoisted_13, [
                            _cache[6] || (_cache[6] = _createElementVNode("td", null, null, -1)),
                            _createElementVNode("td", null, [
                              _createVNode(_component_oss_date_picker_filled, {
                                modelValue: item.newBalanceDate,
                                "onUpdate:modelValue": ($event: any) => ((item.newBalanceDate) = $event),
                                minDate: _ctx.accountingPeriod.start,
                                maxDate: _ctx.accountingPeriod.end,
                                "hide-details": "",
                                onChangeDate: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onNewBalanceDateChanged($event)))
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "minDate", "maxDate"])
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_oss_text_field_filled, {
                                outlined: "",
                                dense: "",
                                "hide-details": "",
                                modelValue: item.newBalance,
                                "onUpdate:modelValue": ($event: any) => ((item.newBalance) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("td", _hoisted_14, [
                              _createVNode(_component_v_btn, {
                                size: "small",
                                rounded: "",
                                disabled: _ctx.disabledNewBalance(item),
                                loading: _ctx.upsertBABLoading,
                                elevation: "0",
                                dark: "",
                                color: "primary",
                                onClick: ($event: any) => (_ctx.addNewBalance(item)),
                                icon: "$add"
                              }, {
                                default: _withCtx(() => _cache[5] || (_cache[5] = [
                                  _createTextVNode(" Ajouter ")
                                ])),
                                _: 2
                              }, 1032, ["disabled", "loading", "onClick"])
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1032, ["headers", "items"])
                    ]))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["headers", "items", "loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}